






import { genVuexComputeds } from '@/main/pages/editFactory';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';

import { store } from '../../store/edit';
import { NAME } from './constants';

export default EditStoreMixin.extend({
	name: 'LogServisniZakazky',

	data() {
		return {
			NAME,
		};
	},
	computed: {
		...genVuexComputeds(store),
	},
});
